// extracted by mini-css-extract-plugin
export default {"reviewsWrapper":"Reviews_reviewsWrapper__UjvR9","revHeader":"Reviews_revHeader__AsBN7"};